var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Drawer', {
    attrs: {
      "class-name": "member_add",
      "title": $t("e7yhal4", "添加成员"),
      "width": _vm.isMobile ? '90%' : '700px',
      "mask-closable": false,
      "styles": _vm.styles
    },
    on: {
      "on-close": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('MemberTabBase', {
    ref: "memberTabBaseRef",
    attrs: {
      "visible": _vm.visible,
      "member": _vm.member,
      "edit": false
    }
  }), _c('div', {
    staticClass: "drawer_footer"
  }, [_c('Button', {
    staticClass: "buttons",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    staticClass: "buttons",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v($t("fu64o34", "立即保存"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.onSubmit('continue');
      }
    }
  }, [_vm._v($t("8xmbtu9", "立即保存并继续添加"))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };